import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  children: PropTypes.element.isRequired,
  asyncPropsMapper: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export class AsyncLoader extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
    };

    this.handleDataFetch = this.handleDataFetch.bind(this);
  }

  handleDataFetch(...args) {
    const { fetchData } = this.props;

    return fetchData(...args).then(data => {
      this.setState({ data });
    });
  }

  render() {
    const { children } = this.props;
    const props = this.state.data
      ? this.props.asyncPropsMapper(children.props, this.state.data)
      : children.props;

    return React.cloneElement(children, {
      ...props,
      fetchData: this.handleDataFetch,
    });
  }
}

AsyncLoader.propTypes = propTypes;
